import { useState } from 'react';
import { Modal } from 'react-bootstrap';

export function InstallWidgetsModal({ show, onHide }) {
  const scriptTag = `<script \n async \n src="${window.location.origin}/lib/masjidal-widget.umd.js"> \n</script>`;
  const [copySuccess, setCopySuccess] = useState('');

  const handleCopy = async () => {
    await navigator.clipboard.writeText(scriptTag);
    setCopySuccess('Copied!');
    setTimeout(() => setCopySuccess(''), 2000);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header>
        <Modal.Title>Installation Guide</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        paddingTop: '1rem',
        paddingBottom: '1rem'
      }}>
        <div style={{
          backgroundColor: '#d3d3d340',
          padding: '1rem',
          borderRadius: '10px',
          color: 'black'
        }
        }>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0">How to install widgets on your website</h5>
          </div>

          <ol className="ps-3">
            <li className="mb-4">
              To start adding donation buttons and forms onto your website,
              copy and paste the code below into the &lt;head&gt; tag of your
              website.
              <div className="position-relative mt-2">
                <pre
                  className="bg-light border rounded p-3 overflow-auto"
                  style={{ whiteSpace: 'pre-wrap' }}
                >
                  {scriptTag}
                </pre>
                <button
                  className="btn btn-outline-primary btn-sm position-absolute top-0 end-0 m-2"
                  onClick={handleCopy}>
                  {copySuccess ? copySuccess : 'Copy'}
                </button>
              </div>
            </li>

            <li className="mb-4">
              When the head code has been added, simply publish a widget
              by selecting "Customize" option on any widget you want to add,
              customize the widget according to your liking and publish it.
            </li>

            <li>
              Once the library is installed and Widget is published, you’ll be able to select “Embed”
              on any widget from the MasjidAl platform and follow the
              provided instructions to add it to your website.
            </li>
          </ol>


        </div>
        <div className="mt-4 text-black">
          <span >Still need help? </span>
          <span className='cursor-pointer text-primary'>masjidsupport@masjidal.com</span>
        </div>
      </Modal.Body>
    </Modal>
  );
}
